const LonLatConversion = function (options) {
  let that = this;
  that.pi = 3.1415926535897932384626;
  that.x_pi = 3.14159265358979324 * 3000.0 / 180.0;
  that.a = 6378245.0;
  that.ee = 0.00669342162296594323;
}
LonLatConversion.prototype = {
  transformData: function (data, type) {

    let that = this;
    let arr = []
    if (type == "bd") {
      data.forEach(item => {
        if (item.location != undefined && item.location.lat != undefined && item.location.lng != undefined) {
          let po = that.BdToGPS(item.location.lat, item.location.lng)
          item.location.lat = po.latitude
          item.location.lng = po.lontitude
          arr.push(item)
        }
      })
    } else if (type == "gd") {
      data.forEach(item => {
        let position = item.location.split(",")
        let po = that.GdToGPS(position[0], position[1])
        let obj = {
          name: item.name,
          location: {
            lat: po.Lat,
            lng: po.Lon
          },
          address: item.address,
          province: item.pname,
          city: item.cityname,
          area: item.adname,
          telephone: item.tel
        }
        arr.push(obj)
      })
    }
    console.log("god:", arr)
    return arr;
  },
  GdToGPS: function (Longitude, Latitude) {
    let that = this;
    let Dev = that.CalDev(Longitude, Latitude);
    let RetLat = Latitude - Dev.Lat;
    let RetLon = Longitude - Dev.Lon;
    Dev = that.CalDev(RetLon, RetLat);
    RetLat = Latitude - Dev.Lat;
    RetLon = Longitude - Dev.Lon;
    let obj = {}
    obj.Lon = RetLon;
    obj.Lat = RetLat;
    return obj;
  },
  CalDev: function (WgLon, WgLat) {
    let that = this
    let obj = {};
    let ee = that.ee //0.00669342162296594323;
    let a = that.a // 6378245.0;
    if (that.outOfChina(WgLat, WgLon)) {
      return obj;
    }
    let Lat = that.CalLat(WgLon - 105.0, WgLat - 35.0);
    let Lon = that.CalLon(WgLon - 105.0, WgLat - 35.0);
    let RadLat = WgLat / 180.0 * Math.PI;
    let Magic = Math.sin(RadLat);
    Magic = 1 - ee * Magic * Magic;
    let SqrtMagic = Math.sqrt(Magic);
    Lat = (Lat * 180.0) / ((a * (1 - ee)) / (Magic * SqrtMagic) * Math.PI);
    Lon = (Lon * 180.0) / (a / SqrtMagic * Math.cos(RadLat) * Math.PI);
    obj.Lon = Lon;
    obj.Lat = Lat;
    return obj;
  },
  CalLat: function (X, Y) {
    let ResultLat = -100.0 + 2.0 * X + 3.0 * Y + 0.2 * Y * Y + 0.1 * X * Y + 0.2 * Math.sqrt(Math.abs(X));
    ResultLat += (20.0 * Math.sin(6.0 * X * Math.PI) + 20.0 * Math.sin(2.0 * X * Math.PI)) * 2.0 / 3.0;
    ResultLat += (20.0 * Math.sin(Y * Math.PI) + 40.0 * Math.sin(Y / 3.0 * Math.PI)) * 2.0 / 3.0;
    ResultLat += (160.0 * Math.sin(Y / 12.0 * Math.PI) + 320 * Math.sin(Y * Math.PI / 30.0)) * 2.0 / 3.0;
    return ResultLat;
  },
  CalLon: function (X, Y) {
    let ResultLon = 300.0 + X + 2.0 * Y + 0.1 * X * X + 0.1 * X * Y + 0.1 * Math.sqrt(Math.abs(X));
    ResultLon += (20.0 * Math.sin(6.0 * X * Math.PI) + 20.0 * Math.sin(2.0 * X * Math.PI)) * 2.0 / 3.0;
    ResultLon += (20.0 * Math.sin(X * Math.PI) + 40.0 * Math.sin(X / 3.0 * Math.PI)) * 2.0 / 3.0;
    ResultLon += (150.0 * Math.sin(X / 12.0 * Math.PI) + 300.0 * Math.sin(X / 30.0 * Math.PI)) * 2.0 / 3.0;
    return ResultLon;
  },
  /*百度转GPS-start*/
  BdToGPS: function (lat, lon) {
    let that = this;
    var gcj02 = that.Bd09ToGcj02(lat, lon);
    var gps84 = that.Gcj02ToGps84(gcj02.tempLat, gcj02.tempLon);
    return gps84;
  },
  Bd09ToGcj02: function (lat, lon) {
    let that = this;
    let x = lon - 0.0065,
      y = lat - 0.006;
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * that.x_pi);
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * that.x_pi);
    let tempLon = z * Math.cos(theta);
    let tempLat = z * Math.sin(theta);
    var gps = {
      tempLat,
      tempLon
    };
    return gps;
  },
  Gcj02ToGps84: function (lat, lon) {
    let that = this
    let gps = that.transform(lat, lon);
    let lontitude = lon * 2 - gps.mgLon;
    let latitude = lat * 2 - gps.mgLat;
    return {
      latitude: latitude,
      lontitude: lontitude
    };
  },
  outOfChina: function (lat, lon) {
    if (lon < 72.004 || lon > 137.8347)
      return true;
    if (lat < 0.8293 || lat > 55.8271)
      return true;
    return false;
  },
  transform: function (lat, lon) {
    let that = this
    if (that.outOfChina(lat, lon)) {
      return {
        mgLat: lat,
        mgLon: lon
      };
    }
    let dLat = that.transformLat(lon - 105.0, lat - 35.0);
    let dLon = that.transformLon(lon - 105.0, lat - 35.0);
    let radLat = lat / 180.0 * that.pi;
    let magic = Math.sin(radLat);
    magic = 1 - that.ee * magic * magic;
    let SqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / ((that.a * (1 - that.ee)) / (magic * SqrtMagic) * that.pi);
    dLon = (dLon * 180.0) / (that.a / SqrtMagic * Math.cos(radLat) * that.pi);
    let mgLat = lat + dLat;
    let mgLon = lon + dLon;
    return {
      mgLat: mgLat,
      mgLon: mgLon
    };
  },
  transformLon: function (x, y) {
    let that = this
    let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 *
      Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * that.pi) + 20.0 * Math.sin(2.0 * x * that.pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * that.pi) + 40.0 * Math.sin(x / 3.0 * that.pi)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * that.pi) + 300.0 * Math.sin(x / 30.0 * that.pi)) * 2.0 / 3.0;
    return ret;
  },
  transformLat(x, y) {
    let that = this
    let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y +
      0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * that.pi) + 20.0 * Math.sin(2.0 * x * that.pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * that.pi) + 40.0 * Math.sin(y / 3.0 * that.pi)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * that.pi) + 320 * Math.sin(y * that.pi / 30.0)) * 2.0 / 3.0;
    return ret;
  }
  /*百度转GPS-End*/

}
export default LonLatConversion;
